const configs = {
    ethereum: {
        name: 'Ethereum',
        blockchainId: 'ethereum',
        coingeckoAssetId: 'ethereum',
        nativeAssetId: 'eth', // Coin id from the blockchain's coins config
        networkId: 1,
        nativeCurrency: {
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrl: 'https://mainnet.infura.io/v3/c334bb4b45a444979057f0fb8a0c9d1b',
        rawStatsPath: 'raw-stats',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://etherscan.io/',
            address: 'https://etherscan.io/address/',
            tx: 'https://etherscan.io/tx/',
        },
        walletGuideUrl: null,
        display: {
            txCostPrecision: 2,
        },
    },
    fantom: {
        name: 'Fantom',
        blockchainId: 'fantom',
        coingeckoAssetId: 'fantom',
        nativeAssetId: 'ftm', // Coin id from the blockchain's coins config
        networkId: 250,
        nativeCurrency: {
            symbol: 'FTM',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.ftm.tools/',
        rawStatsPath: 'raw-stats-ftm',
        logoPath: 'logos/logo_optimized-ftm.svg',
        explorerBaseUrl: {
            root: 'https://ftmscan.com/',
            address: 'https://ftmscan.com/address/',
            tx: 'https://ftmscan.com/tx/',
        },
        walletGuideUrl: 'https://resources.curve.fi/guides/using-curve-on-fantom',
        display: {
            txCostPrecision: 5,
        },
    },
    bsc: {
        name: 'Binance Smart Chain',
        blockchainId: 'bsc',
        coingeckoAssetId: 'bsc',
        nativeAssetId: 'bnb', // Coin id from the blockchain's coins config
        networkId: 56,
        nativeCurrency: {
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrl: 'https://bsc-dataseed.binance.org/',
        rawStatsPath: 'raw-stats-bsc',
        logoPath: 'logos/logo_optimized-ftm.svg',
        explorerBaseUrl: {
            root: 'https://bscscan.com/',
            address: 'https://bscscan.com/address/',
            tx: 'https://bscscan.com/tx/',
        },
        walletGuideUrl: 'https://resources.curve.fi/guides/using-curve-on-fantom',
        display: {
            txCostPrecision: 5,
        },
    },
    polygon: {
        name: 'Polygon',
        blockchainId: 'polygon',
        coingeckoAssetId: 'matic-network',
        nativeAssetId: 'MATIC', // Coin id from the blockchain's coins config
        networkId: 137,
        nativeCurrency: {
            symbol: 'MATIC',
            decimals: 18,
        },
        rpcUrl: 'https://polygon-mainnet.infura.io/v3/fac98e56ea7e49608825dfc726fab703',
        rawStatsPath: 'raw-stats-polygon',
        logoPath: 'logos/logo_optimized-polygon.svg',
        explorerBaseUrl: {
            root: 'https://polygonscan.com/',
            address: 'https://polygonscan.com/address/',
            tx: 'https://polygonscan.com/tx/',
        },
        walletGuideUrl: 'https://blog.matic.network/deposits-and-withdrawals-on-matic-network-walkthrough-guide/',
        display: {
            txCostPrecision: 5,
        },
    },
    xdai: {
        name: 'xDai',
        blockchainId: 'xdai',
        coingeckoAssetId: 'xdai-stake',
        nativeAssetId: 'STAKE', // Coin id from the blockchain's coins config
        networkId: 100,
        nativeCurrency: {
            symbol: 'xDai',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.xdaichain.com/curve',
        rawStatsPath: 'raw-stats-xdai',
        logoPath: 'logos/logo_optimized-xdai.svg',
        explorerBaseUrl: {
            root: 'https://blockscout.com/xdai/mainnet/',
            address: 'https://blockscout.com/xdai/mainnet/address/',
            tx: 'https://blockscout.com/xdai/mainnet/tx/',
        },
        walletGuideUrl: 'https://www.xdaichain.com/for-users/wallets/metamask/metamask-setup',
        display: {
            txCostPrecision: 5,
        },
    },
}

const getConfig = () => {
    const id = process.env.VUE_APP_BLOCKCHAIN_ID;
    const supportedIds = Array.from(Object.keys(configs));

    if (!supportedIds.includes(id)) {
        throw new Error(`Invalid env variable VUE_APP_BLOCKCHAIN_ID: "${id}"`);
    }

    return configs[id];
};

module.exports = getConfig();

// swap  0x7f90122BF0700F9E7e1F688fe926940E8839F353
// token  0x1337BedC9D22ecbe766dF105c9623922A27963EC
